<template>
    <v-dialog
        v-model="showDialog"
        width="900"
    >
        <v-card>
            <v-card-title style="background-color: #009688; font-size: 15px; color: white;">
                {{ showSpecialDeals.acctName }}
                <v-spacer />
                <v-tooltip top>
                    <template #activator="{ on }">
                        <v-btn
                            elevation="2"
                            color="pr"
                            v-on="on"
                            @click="handleChangeColor"
                        >
                            <v-icon>{{ mdiThemeLightDark }}</v-icon>change theme
                        </v-btn>
                    </template>
                    <span>Change Theme</span>
                </v-tooltip>
                &nbsp;
                <v-tooltip top>
                    <template #activator="{ on }">
                        <v-btn
                            elevation="2"
                            :dark="true"
                            color="error"
                            v-on="on"
                            @click="showDialog = false"
                        >
                            <v-icon>{{ mdiClose }}</v-icon>close
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text
                ref="scrollableContent"
                :style="`background-color: ${darkTheme == 0 ? '#FAFAFA' : darkTheme == 1 ? '#FFFFC0' : '#1C1C1C'}; color: ${darkTheme == 0 ? '#1A1A1A' : darkTheme == 1 ? '#0E0E0E' : '#EDEDED'}; box-shadow: inset 0 4px 10px rgba(0, 0, 0, 0.2); padding-top: 20px; height: 80vh; overflow-y: scroll;`"
            >
                <pre style="font-size: 15px; white-space: pre-wrap; line-height: 1.6; font-weight: 400; font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;">{{ showSpecialDeals.path }}</pre>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar.status"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
            <template #action="{ attrs }">
                <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    style="text-transform: none;"
                    @click="snackbar.status = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import {
    mdiThemeLightDark,
    mdiClose
} from '@mdi/js'
export default {
    props: ['showSpecialDeals'],
    data: ()=>({
        mdiThemeLightDark,
        mdiClose,
        darkTheme: 0,
        contractUrl: null,
        snackbar: {
            status: null,
            text: null,
            timeout: 2000
        }
    }),
    computed: {
        showDialog: {
            get() {
                return this.showSpecialDeals.status
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        showDialog(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    if (this.$refs.scrollableContent) {
                        this.$refs.scrollableContent.scrollTop = 0
                    }
                })
            } else {
                this.darkTheme = 0
            }
        },
        showSpecialDeals: {
            handler(newVal) {
                if (newVal.status) {
                    this.contractUrl = newVal.path
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleChangeColor() {
            if (this.darkTheme == 2) {
                this.darkTheme = 0
            } else {
                this.darkTheme++
            }
        },
        handleCopyContractPathFunc() {
            const contractPath = `file://${this.contractUrl}`

            if (!contractPath) {
                this.snackbar.status = true
                this.snackbar.text = 'No contract path to copy.'
                return
            }

            // Modern approach - Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(contractPath)
                    .then(() => {
                        this.snackbar.status = true
                        this.snackbar.text = 'Contract path copied successfully!'
                    })
                    .catch(() => {
                        // Fall back to the alternative method if the Clipboard API fails
                        this.copyToClipboardFallback(contractPath)
                    })
            } else {
                // Fallback for older browsers or non-secure contexts
                this.copyToClipboardFallback(contractPath)
            }
        },

        // Separate fallback method for better organization
        copyToClipboardFallback(text) {
            try {
                const textArea = document.createElement('textarea')
                textArea.value = text

                // Make the textarea out of viewport
                textArea.style.position = 'fixed'
                textArea.style.left = '-999999px'
                textArea.style.top = '-999999px'
                textArea.style.zIndex = '999999'
                textArea.setAttribute('readonly', '') // Prevent mobile keyboard from appearing

                // For dialogs, we need to append to the dialog or root element
                // Find the dialog if it's open
                const activeDialog = document.querySelector('.v-dialog--active')
                const appendTarget = activeDialog || document.body

                appendTarget.appendChild(textArea)

                // Handle iOS devices specifically
                if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                    textArea.contentEditable = true
                    textArea.readOnly = false
                    const range = document.createRange()
                    range.selectNodeContents(textArea)
                    const selection = window.getSelection()
                    selection.removeAllRanges()
                    selection.addRange(range)
                    textArea.setSelectionRange(0, 999999)
                } else {
                    textArea.select()
                }

                const successful = document.execCommand('copy')

                if (successful) {
                    this.snackbar.status = true
                    this.snackbar.text = 'Contract path copied successfully!'
                } else {
                    this.snackbar.status = true
                    this.snackbar.text = 'Failed to copy contract path. Please try again.'
                }
            } catch (err) {
                // console.error('Copy fallback error:', err);
                this.snackbar.status = true
                this.snackbar.text = 'Failed to copy contract path. Please try again.'
            } finally {
                // Find and remove the textarea, wherever it was appended
                const textArea = document.querySelector('textarea[style*="position: fixed"][style*="left: -999999px"]')
                if (textArea && textArea.parentNode) {
                    textArea.parentNode.removeChild(textArea)
                }
            }
        }
    }
}
</script>
